// 脆球域名邮箱
if (process.env.VUE_APP_PRODUCT === 'cuiqiu_auth') {
    if (process.env.NODE_ENV === 'development') {
        module.exports = {
            API_URL: 'http://localhost:6215',
            // API_URL: 'https://mail-api-dev.cuiqiu.com',
            ADMIN_INDEX: 'http://localhost:9002',
            COOKIES: {
                SET_DOMAIN: 'localhost',
                TOKEN: 'cuiqiu-token',
                LOGIN_TEL_NUM_MAIL: 'cuiqiu-tel-num',
                INVITE: 'cuiqiu-invite',
                LOCATION: 'cuiqiu-mail-location',
                REFERRER: 'cuiqiu-mail-referrer',
                LANGUAGE: 'cuiqiu-language'
            },
            LOGIN_TYPE: 'tel'
        }
    } else if (process.env.NODE_ENV === 'test') {
        module.exports = {
            API_URL: 'https://auth-api-test.cuiqiu.com',
            ADMIN_INDEX: 'https://mail-test.cuiqiu.com',
            COOKIES: {
                SET_DOMAIN: 'cuiqiu.com',
                TOKEN: 'cuiqiu-token',
                LOGIN_TEL_NUM_MAIL: 'cuiqiu-tel-num',
                INVITE: 'cuiqiu-invite',
                LOCATION: 'cuiqiu-mail-location',
                REFERRER: 'cuiqiu-mail-referrer',
                LANGUAGE: 'cuiqiu-language'
            },
            LOGIN_TYPE: 'tel'
        }
    } else {
        module.exports = {
            API_URL: 'https://auth-api.cuiqiu.com',
            ADMIN_INDEX: 'https://mail-admin.cuiqiu.com',
            COOKIES: {
                SET_DOMAIN: 'cuiqiu.com',
                TOKEN: 'cuiqiu-token',
                LOGIN_TEL_NUM_MAIL: 'cuiqiu-tel-num',
                INVITE: 'cuiqiu-invite',
                LOCATION: 'cuiqiu-mail-location',
                REFERRER: 'cuiqiu-mail-referrer',
                LANGUAGE: 'cuiqiu-language'
            },
            LOGIN_TYPE: 'tel'
        }
    }
}

// GetMX
if (process.env.VUE_APP_PRODUCT === 'getmx_auth') {
    if (process.env.NODE_ENV === 'development') {
        module.exports = {
            API_URL: 'http://localhost:6215',
            // API_URL: 'https://mail-api-dev.getmx.com',
            ADMIN_INDEX: 'http://localhost:9002',
            COOKIES: {
                SET_DOMAIN: 'localhost',
                TOKEN: 'getmx-token',
                LOGIN_TEL_NUM_MAIL: 'getmx-mail',
                INVITE: 'getmx-invite',
                LOCATION: 'getmx-mail-location',
                REFERRER: 'getmx-mail-referrer',
                LANGUAGE: 'getmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    } else if (process.env.NODE_ENV === 'test') {
        module.exports = {
            API_URL: 'https://auth-api-test.getmx.com',
            ADMIN_INDEX: 'https://mail-test.getmx.com',
            COOKIES: {
                SET_DOMAIN: 'getmx.com',
                TOKEN: 'getmx-token',
                LOGIN_TEL_NUM_MAIL: 'getmx-mail',
                INVITE: 'getmx-invite',
                LOCATION: 'getmx-mail-location',
                REFERRER: 'getmx-mail-referrer',
                LANGUAGE: 'getmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    } else {
        module.exports = {
            API_URL: 'https://auth-api.getmx.com',
            ADMIN_INDEX: 'https://mail-admin.getmx.com',
            COOKIES: {
                SET_DOMAIN: 'getmx.com',
                TOKEN: 'getmx-token',
                LOGIN_TEL_NUM_MAIL: 'getmx-mail',
                INVITE: 'getmx-invite',
                LOCATION: 'getmx-mail-location',
                REFERRER: 'getmx-mail-referrer',
                LANGUAGE: 'getmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    }
}

// PinMX
if (process.env.VUE_APP_PRODUCT === 'pinmx_auth') {
    if (process.env.NODE_ENV === 'development') {
        module.exports = {
            API_URL: 'http://localhost:6215',
            // API_URL: 'https://mail-api-dev.pinmx.com',
            ADMIN_INDEX: 'http://localhost:9002',
            COOKIES: {
                SET_DOMAIN: 'localhost',
                TOKEN: 'pinmx-token',
                LOGIN_TEL_NUM_MAIL: 'pinmx-mail',
                INVITE: 'pinmx-invite',
                LOCATION: 'pinmx-mail-location',
                REFERRER: 'pinmx-mail-referrer',
                LANGUAGE: 'pinmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    } else if (process.env.NODE_ENV === 'test') {
        module.exports = {
            API_URL: 'https://auth-api-test.pinmx.com',
            ADMIN_INDEX: 'https://mail-test.pinmx.com',
            COOKIES: {
                SET_DOMAIN: 'pinmx.com',
                TOKEN: 'pinmx-token',
                LOGIN_TEL_NUM_MAIL: 'pinmx-mail',
                INVITE: 'pinmx-invite',
                LOCATION: 'pinmx-mail-location',
                REFERRER: 'pinmx-mail-referrer',
                LANGUAGE: 'pinmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    } else {
        module.exports = {
            API_URL: 'https://auth-api.pinmx.com',
            ADMIN_INDEX: 'https://mail-admin.pinmx.com',
            COOKIES: {
                SET_DOMAIN: 'pinmx.com',
                TOKEN: 'pinmx-token',
                LOGIN_TEL_NUM_MAIL: 'pinmx-mail',
                INVITE: 'pinmx-invite',
                LOCATION: 'pinmx-mail-location',
                REFERRER: 'pinmx-mail-referrer',
                LANGUAGE: 'pinmx-language'
            },
            LOGIN_TYPE: 'mail'
        }
    }
}
